<template>
  <div class="main-layout">
    <NavBar />

    <!-- esto ocupa todo el espacio restante -->
    <div class="content-wrapper">
      <router-view />
    </div>

    <AppFooter class="app-footer" />
  </div>
</template>

<script>
import NavBar from '@/components/NavBar.vue'
import AppFooter from '@/components/AppFooter.vue'

export default {
  name: 'MainLayout',
  components: { NavBar, AppFooter }
}
</script>

<style scoped>
.main-layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh; /* siempre ocupa toda la pantalla */
}

.content-wrapper {
  flex: 1;           /* crece para empujar el footer al fondo */
}

/* estilos del footer */
.app-footer {
  margin-top: 2rem;      /* separa el footer del contenido */
  background-color: #333;/* gris oscuro */
  color: #fff;
  padding: 2rem 0;
}
/* si quieres usar tu clase dark-background: */
/*
.app-footer.dark-background { 
  background-color: #333;
}
*/
</style>
